import axios from 'axios';
import Cookie from 'cookies-js';
import toastr from 'toastr';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  FIX_TIP_INVESTMENT,
  FIX_TIP_INVESTMENT_ERROR,
  FIX_TIP_INVESTMENT_LOADING,
  FIX_TIP_INVESTMENT_ERROR_DELETE
} from '../types';

const fixtipInvestmentSuccess = fixtip => ({
  type: FIX_TIP_INVESTMENT,
  fixtip
});

const fixtipInvestmentLoading = () => ({
  type: FIX_TIP_INVESTMENT_LOADING
});

const fixtipInvestmentError = error => ({
  type: FIX_TIP_INVESTMENT_ERROR,
  error
});

export const deletefixtipInvestmentError = () => ({
  type: FIX_TIP_INVESTMENT_ERROR_DELETE
});

const fixtipInvestment = fixtipDetails => (dispatch) => {
  dispatch(fixtipInvestmentLoading());
  const token = Cookie.get('jwtToken');
  return axios.post(`${config.apiUrl}${routes.FIXTIPINVESTMENT}`, fixtipDetails, {
    headers: { Authorization: `Bearer ${token}` }
  }).then((response) => {
    dispatch(fixtipInvestmentLoading());
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(fixtipInvestmentSuccess(data));
      toastr.success('Success! Your Fix Tip Investment was successful.');
    } else {
      dispatch(fixtipInvestmentError(data.responseMessage));
    }
  }).catch((error) => {
    const { data } = error.response;
    dispatch(fixtipInvestmentLoading());
    if (data.responseMessage === 'Bvn Does Not Exist') {
      const message = 'Kindly add your bvn details in other to buy a fund.';
      toastr.error(message);
      dispatch(fixtipInvestmentError(message));
    } else {
      dispatch(fixtipInvestmentError(data.responseMessage));
      toastr.error(data.responseMessage);
    }

    throw error;
  });
};

export default fixtipInvestment;
